module.exports = __webpack_public_path__ + "static/guild_artisan-831b5dfdfb741ba58b4fd35a709408e0.jpg";